import moment from 'moment';
import { addDateFormatting, calculateExpDate, getStoreState } from '@cogitate/ui-multi-utils';
import { dateKeys } from 'ui/data/constants/keys';
import { storeKeys } from 'ui/data/constants/keys';
import { INITIAL_FILE_CHANGES } from 'ui/redux/action-types/helperActionTypes';
import { masterModalHelper } from 'ui/redux/actions';

const d = moment();
const dformat = d.format(dateKeys.DateFormatyyymmdd);
const defaultExpiryDate = calculateExpDate(dformat, '12');
const DefQuoteExpDate = moment().toDate();
const defaultQuoteExpDate = addDateFormatting(dateKeys.Days, DefQuoteExpDate, 30);

function getInitialState() {
  let initialData = getStoreState(storeKeys.DataReducer).initialData;
  const selectedBusinessLine = getStoreState(storeKeys.ApplicationReducer).selectedBusinessLine;
  const lob = `${selectedBusinessLine?.line}/${selectedBusinessLine?.lineOfBusiness}`.toLowerCase() || '';
  const commonInitializations = {
    EffectiveDate: dformat,
    ExpirationDate: defaultExpiryDate,
    QuoteDate: dformat,
    QuoteExpDate: defaultQuoteExpDate,
    Attributes: {
      ...initialData?.Attributes,
      UISchemaVersion: process.env.NEXT_PUBLIC_DEFAULT_VERSION,
      Client: process.env.NEXT_PUBLIC_CLIENT,
    },
    Transaction: {
      ...initialData?.Transaction,
      EffectiveDate: dformat,
      Date: dformat,
    },
  };

  initialData = {
    ...initialData,
    ...commonInitializations,
  };
  return masterModalHelper(INITIAL_FILE_CHANGES, lob, [initialData], () => {});
}

export { getInitialState };
